import { FC } from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { useParams } from 'react-router-dom';

import { NSKeys } from '@app/i18n';
import { useLocalSelector } from '@app/services/hooks/useRedux';

import { useExportQuery } from '../../../../../../hooks';
import { useProcessDataParams } from '../../../../../../providers';

export const ExportButton: FC = () => {
  const { token } = theme.useToken();
  const params = useParams<{ processId: string }>();
  const ordersT = useTranslation(NSKeys.orders);
  const currentSession = useLocalSelector((state) => state.currentSession);
  const { queryParams } = useProcessDataParams();

  const { mutate, status } = useExportQuery();

  if (!currentSession.ordersContext?.scope?.$permissions?.export_orders || !params.processId) {
    return null;
  }

  return (
    <Tooltip placement="bottomLeft" title={ordersT.t('exportTooltip')}>
      <Button
        icon={<DownloadOutlined style={{ color: token.colorPrimary }} />}
        loading={status === 'loading'}
        onClick={() => mutate({ uid: params.processId || '', ...queryParams })}
      />
    </Tooltip>
  );
};
